module.exports = __webpack_public_path__ + "img/preview2.7396b414.png";